import { css } from 'lit';

export default css`
    :host {
        --logo-width: 180px;
    }

    .nav {
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: var(--metrics-spacing-s) var(--metrics-spacing-m);
        background-color: var(--color-surface-primary);
        border-bottom: 1px solid var(--color-border-divider-light);
    }

    .nav-logo {
        display: flex;
        align-items: center;
        gap: var(--metrics-spacing-s);
        margin-left: var(--metrics-spacing-m);
    }

    .nav-logo > img {
        width: var(--logo-width);
        cursor: pointer;
    }

    .nav-logo > div {
        font-size: var(--font-size-head-s);
        font-weight: var(--font-weight-body-m);
        color: var(--color-text-secondary);
    }
`;
